import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import './CustomDropdown.css';

export interface CustomDropdownOption {
    key: string;
    name: string;
}

export interface CustomDropdownProps {
    label: string;
    options: CustomDropdownOption[];
    selectedKey: string;
    onSelect: (key: string) => void;
    disabled?: boolean;
}

/**
 * CustomDropdown wraps React-Bootstrap's DropdownButton/Dropdown
 * in order to provide a consistent, stylable control for category filtering.
 */
const CustomDropdown: React.FC<CustomDropdownProps> = ({
                                                           label,
                                                           options,
                                                           selectedKey,
                                                           onSelect,
                                                           disabled = false,
                                                       }) => {
    const title = selectedKey
        ? options.find((opt) => opt.key === selectedKey)?.name
        : 'Alla';

    return (
        <div className="custom-dropdown-root">
            <label className="custom-dropdown-label">{label}</label>

            <DropdownButton
                id={`${label.toLowerCase().replace(/\s+/g, '-')}-dropdown`}
                variant="secondary"
                title={title}
                disabled={disabled}
                className="custom-dropdown-button"
            >
                <Dropdown.Item
                    active={!selectedKey}
                    onClick={() => onSelect('')}
                    className="custom-dropdown-item"
                >
                    Alla
                </Dropdown.Item>

                {options.map((option) => (
                    <Dropdown.Item
                        key={option.key}
                        active={option.key === selectedKey}
                        onClick={() => onSelect(option.key)}
                        className="custom-dropdown-item"
                    >
                        {option.name}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        </div>
    );
};

export default CustomDropdown;
